import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Fab, Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import AddIcon from '@mui/icons-material/Add';
import ReactDOM from 'react-dom';

const styles = theme => ({
    fab: {
        position: 'sticky',
        zIndex: 1000,
        left: '100%',
        bottom: theme.spacing(2),
        width: 'fit-content',
        paddingRight: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign: 'right',
    }
});

class CommonFab extends Component {
    constructor(props) {
        super(props);
        this.el = document.createElement('div');
    }

    componentDidMount() {
        this.footer = document.querySelector('.footer');

        this.el.classList.add(this.props.classes.fab);
        this.footer && this.footer.parentElement.insertBefore(this.el, this.footer);
    }

    componentWillUnmount() {
        this.footer.parentElement.removeChild(this.el);
    }

    render() {
        const { tooltipTranslateId, placement, color, onClick, t } = this.props;

        return ReactDOM.createPortal(
            <Tooltip
                title={t(tooltipTranslateId)}
                placement={placement}
            >
                <Fab
                    color={color}
                    onClick={onClick}
                    aria-label="Add new item"
                >
                    <AddIcon />
                </Fab>
            </Tooltip>,
            this.el
        );
    }
}

CommonFab.propTypes = {
    tooltipTranslateId: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    placement: PropTypes.string,
    color: PropTypes.string,
    onClick: PropTypes.func.isRequired
};

CommonFab.defaultProps = {
    placement: 'left',
    color: 'secondary'
};

export default withStyles(styles)(CommonFab);
